import Lang from '/@/modules/core/app/services/Lang';
import { ContactUsDetails } from '/@/modules/auth/constants/ContactUsDetails';

export const ContactUsInfoMixin = {
  computed: {
    contactEmail() {
      return ContactUsDetails[Lang.locale].CONTACT_EMAIL;
    },
    termsOfUse() {
      return ContactUsDetails[Lang.locale].TERMS_OF_USE;
    },
    privacyPolicy() {
      return ContactUsDetails[Lang.locale].PRIVACY_POLICY;
    }
  }
};
